import billingConfig from '../../../../components/deposits/billing';

class PaymentsService {
    constructor(locale) {
        this.locale = locale;
    }

    getAllTypes() {
        return this.locale.ready(['billing']).then(() => {
            const out = [];
            _.each(billingConfig.payments.types, (type) => {
                out.push({
                    key: type,
                    title: this.locale.getString('billing.payments.types.' + type)
                })
            });

            return out;
        });
    }

    getPosTypes() {
        return this.locale.ready(['billing']).then(() => {
            const out = [];
            _.each(billingConfig.payments.pos_types, (type) => {
                out.push({
                    key: type,
                    title: this.locale.getString('billing.payments.types.' + type)
                })
            });

            return out;
        });
    }

    getAllStates() {
        return this.locale.ready(['billing']).then(() => {
            const out = [];
            _.each(billingConfig.payments.states, (status) => {
                out.push({
                    key: status,
                    title: this.locale.getString('billing.payments.states.' + status)
                })
            });

            return out;
        });
    }
}

/**
 * @ngdoc service
 * @name billing.invoices.services:InvoiceActionsService
 *
 * @description
 *
 */
angular
    .module('festzelt-os.billing.invoices')
    .factory('PaymentsService', [
        'locale',
        (locale) => new PaymentsService(locale)
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/billing/invoices/services/payments-service.js